import {AddressCardStyle} from "./addressCard.style";
import {CustomRadioComponent} from "../../customRadio/customRadio.component";
import {Badge, Button, CardText, Spinner} from "reactstrap";
import {IoLocationOutline} from "react-icons/io5";
import {FiTrash2} from "react-icons/fi";
import {useState} from "react";

export const AddressCardComponent = ({
                                         includeSelect = true,
                                         address,
                                         onSelect,
                                         includeDelete = true,
                                         active = false,
                                         onDelete,
                                     }) => {
    const [deleting, setDeleting] = useState(false);

    const handleDelete = async () => {
        if (!address?._id) return;
        setDeleting(true);
        try {
            await onDelete(address._id);
        } catch (err) {
            console.error(err);
        } finally {
            setDeleting(false);
        }
    };

    if (!address) return null;
    return <AddressCardStyle $active={active} className={`${active ? "active" : ""}`}>
        {includeSelect && (<CustomRadioComponent checked={active} onChange={() => onSelect?.(address)}/>)}
        <div className={"text"}>
            <h4 className="title">
                {address.firstName || ""} {address.lastName || ""}
            </h4>
            <CardText className="card-location mt-2 card-location flex-nowrap d-flex align-items-center">
                <IoLocationOutline/>
                {address.street}
            </CardText>
            {includeDelete && <Button className="mt-3" onClick={handleDelete} disabled={deleting}>
                {deleting ? (<>
                    <Spinner size="sm" className="me-2"/>
                </>) : (<>
                    <FiTrash2/> Delete
                </>)}
            </Button>}
        </div>

        {active && (<Badge className="default-indicator" pill>
            <b>Default</b>
        </Badge>)}
    </AddressCardStyle>
};
